import React from 'react';
import { useSelector } from 'react-redux';
import useCreditToBeApplied from 'products/nomad_insurance/hooks/useCreditToBeApplied';
import { StyledFeedback, FeedbackHeading } from './styled';

const CreditFeedback = () => {
  const { creditToBeApplied } = useCreditToBeApplied();
  const { hasEndDate } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );

  if (!creditToBeApplied) return null;

  if (hasEndDate) {
    return (
      <StyledFeedback variant="failure" topAlignIcon>
        <FeedbackHeading>
          Your chosen policy is not eligible for the ${creditToBeApplied.creditAmount}{' '}
          credit
        </FeedbackHeading>
        Your ${creditToBeApplied.creditAmount} credit can only be applied to our
        pay-as-you-go option with no predefined end date. You can still cancel anytime.
      </StyledFeedback>
    );
  }

  return (
    <StyledFeedback variant="success">
      Your ${creditToBeApplied.creditAmount} credit has been automatically applied!
    </StyledFeedback>
  );
};

export default CreditFeedback;
